import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    appObjects: {
        active: false,
        sleepTime: 0,
    }
}

const AppReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.APP_UPDATE_APPOBJECTS:
            return {
                loading: true
            }
        case actionTypes.APP_UPDATE_APPOBJECTS_SUCCESS:
            return {
                loading: false,
                appObjects: { ...state.appObjects, ...action.payload }
            }
        default:
            return state;
    }
}

export default AppReducer;